import Vue from "vue";
import Vuex from "vuex";

import createPersistedState from "vuex-persistedstate";
import { moduleUser } from "./modules/user";
import { createCenterAvailabilityModule } from "./modules/centerAvailability.mjs";
import { createNotificationsModule } from "./modules/notifications.mjs";

Vue.use(Vuex);

let userState = createPersistedState({
  key: "vuex_user",
  paths: [
    "user.isLoggedIn",
    "user.userdata",
    "user.token",
    "user.hasGroups",
    "user.localnet",
  ],
  storage: window.localStorage,
  filter: (mutation) =>
    ["userdata", "isLoggedIn", "localnet", "token", "resetIdentity", "setIdentity"].includes(mutation.type),
});

//init store
const store = new Vuex.Store({
  modules: {
    user: moduleUser,
    centerAvailability: createCenterAvailabilityModule(),
    notifications: createNotificationsModule(),
  },
  state: () => ({
    version: undefined,
    socketmessage: undefined,
    socketchannel: undefined,
    socketconnected: true, // Inizializziamo a true, diventerà false se disconnesso
    caporeparto: undefined,
    requestpin: undefined,
  }),
  mutations: {
    version(state, version) {
      state.version = version;
    },
    socketmessage(state, payload) {
      state.socketmessage = payload;
    },
    socketchannel(state, payload) {
      state.socketchannel = payload;
    },
    socketconnected(state, payload) {
      state.socketconnected = payload;
    },
    caporeparto(state, payload) {
      state.caporeparto = payload;
    },
    requestpin(state, payload) {
      state.requestpin = payload;
    },
  },
  actions: {
    socketmessage({ commit }, payload) {
      commit("socketmessage", payload);
    },
    socketchannel({ commit }, payload) {
      commit("socketchannel", payload);
    },
    socketconnected({ commit }, payload) {
      commit("socketconnected", payload);
    },
  },
  getters: {
    version: (state) => {
      return state.version;
    },
    socketmessage: (state) => {
      return state.socketmessage;
    },
    socketchannel: (state) => {
      return state.socketchannel;
    },
    socketconnected: (state) => {
      return state.socketconnected;
    },
    caporeparto: (state) => {
      return state.caporeparto;
    },
    requestpin: (state) => {
      return state.requestpin;
    },
  },
  plugins: [userState],
});

// store.registerModule('ciaone', moduleFasiOperatore)
store.subscribe(mutation => {
  if (["resetIdentity", "setIdentity", "token", "isLoggedIn", "userdata"].includes(mutation.type)) store.dispatch("centerAvailability/restorePreference");
});
export default store;
